import { day } from 'libs/day';
import { z } from 'zod';

import { withDateRangeSchema } from '@app/src/app/shared/services/filtering/utils/query-filtering.utils';

import { MediaBreakpoints } from '@shared/services/media';

import { FtmPeriodColumns } from '../types/ftm-periods.types';

export enum FtmPeriodsMessages {
  BUTTON_LABEL_NEW = 'Create period',

  COLUMN_LABEL_TITLE = 'Title',
  COLUMN_LABEL_DATE = 'Date',
  COLUMN_LABEL_TIME = 'Time',
  COLUMN_LABEL_STATUS = 'Status',
  COLUMN_LABEL_TOTAL_REGISTERED = 'Registered',
  COLUMN_LABEL_ALL_ACTIVITIES = 'All Activities',
  COLUMN_LABEL_MY_ACTIVITIES = 'My Activities',
  COLUMN_LABEL_CLONE = 'Clone',
  COLUMN_LABEL_EDIT = 'Edit',

  BUTTON_LABEL_ADD_ACTIVITY = 'Add',

  FIELD_LABEL_SEARCH = 'Search by title',

  EMPTY_STATE_TITLE = 'No results found',
  EMPTY_STATE_SUBTITLE = 'You have no flex periods yet or your search did not match any results.',
}

export const FTM_PERIODS_DISPLAY_COLUMNS: FtmPeriodColumns[] = [
  'title',
  'date',
  'time',
  'status',
  'totalRegistered',
  'activities',
  'myActivities',
];

export enum PeriodLockingIcons {
  ADD_LOCKED = 'mg-lock',
  TEACHER_LOCKED = 'mg-lock-teacher',
  STUDENT_LOCKED = 'mg-lock-student',
  ADD_UNLOCKED = 'mg-lock-open',
  TEACHER_UNLOCKED = 'mg-lock-open-teacher',
  STUDENT_UNLOCKED = 'mg-lock-open-student',
}

export enum PeriodLockingIconSizes {
  MEDIUM = 'medium',
  LARGE = 'large',
}

export const MOBILE_BREAKPOINTS: MediaBreakpoints[] = ['xsmall', 'small', 'medium'];

export const flexPeriodQuerySchema = withDateRangeSchema({
  startDate: day(),
  endDate: day().add(1, 'month'),
}).extend({
  title: z.string().catch(''),
});

export type FlexPeriodQueryParams = z.infer<typeof flexPeriodQuerySchema>;
